// extracted by mini-css-extract-plugin
export default {"pinpop":"PinPopTray_pinpop__kmeP5"};